/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lib_Error_Serverissues1Inputs */

const en_lib_error_serverissues1 = /** @type {(inputs: Lib_Error_Serverissues1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server appears to be experiencing issues. Please try again in a few moments.`)
};

/**
* | output |
* | --- |
* | "The server appears to be experiencing issues. Please try again in a few moments." |
*
* @param {Lib_Error_Serverissues1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lib_error_serverissues1 = /** @type {((inputs?: Lib_Error_Serverissues1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lib_Error_Serverissues1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lib_error_serverissues1(inputs)
});
export { lib_error_serverissues1 as "lib.error.serverIssues" }